import React, { useContext, useRef, useState, useEffect } from "react";
import "./Navbar.css";
import cart_icon from "../Assets/cart_icon.png";
import nav_dropdown from "../Assets/nav_dropdown.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../Context/ShopContext";
import { useNavigate } from "react-router";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import BottomNav from "./Bottom-Nav";

const Navbar = ({ isHomePage }) => {
  const [menu, setMenu] = useState("shop");
  const { cartItems, getTotalCartItems } =
    useContext(ShopContext);
  // const [scrollUp, setScrollUp] = useState(true);
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const menuRef = useRef();
  const imageRef = useRef();
  const Navigate = useNavigate();
  const lastScrollY = useRef(window.scrollY);

  // Fetch all categories  which has subcategories!
  useEffect(() => {
    const fetchCategoriesWithSubcategories = async () => {
      try {
        const response = await axios.get(
          "https://kraafty-backend.onrender.com/api/get-all-category-list/"
        );

        if (response.data && response.data.categories) {
          const filteredCategories = response.data.categories.filter(
            (category) =>
              category.subcategories && category.subcategories.length > 0
          );

          setCategories(filteredCategories);
        }
      } catch (error) {
        console.error("Failed to fetch categories with subcategories:", error);
      }
    };

    // Call the function
    fetchCategoriesWithSubcategories();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Toggle search box visibility
  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
    if (!isSearchOpen) {
      // Focus on search input when opening
      setTimeout(() => {
        const searchInput = document.querySelector('.search-overlay-input');
        if (searchInput) searchInput.focus();
      }, 100);
    }
  };

  // Close search box
  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchQuery("");
  };

  // Close search when clicking outside
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeSearch();
    }
  };

  // Perform the search
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    try {
      Navigate(`/search?query=${searchQuery}`);
      closeSearch();
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const dropdownToggle = (e) => {
    menuRef?.current?.classList?.toggle("nav-menu-visible");
    e?.target?.classList?.toggle("open");
  };


  // Recalculate cart count whenever cartItems changes
  useEffect(() => {
    getTotalCartItems();
  }, [cartItems]);


  // Scroll listener to hide/show Navbar based on scroll direction
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // setScrollUp(currentScrollY < lastScrollY.current || currentScrollY <= 100);
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* Top red bar */}
      <div className="navbar-top-bar"></div>
      
      <div className={`navbar visible' ${isHomePage ? "home" : "not-home"}`}>
        {/* nav with logo */}
        <div className="navbar-horizontal">
          {/* Hamburger menu */}
          <div className="nav-hamburger" onClick={dropdownToggle}>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>

          {/* Brand text */}
          <div className="nav-brand-container">
            <Link to="/" onClick={() => setMenu("shop")} className="nav-logo">
              <span className="nav-brand-text">House of GarV</span>
            </Link>
          </div>

          {/* Right side icons */}
          <div className="nav-icons">
            <button className="nav-search-icon" onClick={toggleSearch}>
              <FaSearch size={20} />
            </button>
            
            <Link to="/cart" className="nav-cart-link">
              <img src={cart_icon} alt="Cart" />
              <div className="nav-cart-count">{getTotalCartItems()}</div>
            </Link>
          </div>
        </div>

        {/* Search Overlay */}
        {isSearchOpen && (
          <div className="search-overlay" onClick={handleOverlayClick}>
            <div className="search-overlay-content">
              <form onSubmit={handleSearchSubmit} className="search-overlay-form">
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="search-overlay-input"
                  autoFocus
                />
                <button type="submit" className="search-overlay-button">
                  <FaSearch size={18} />
                </button>
                <button type="button" className="search-overlay-close" onClick={closeSearch}>
                  ×
                </button>
              </form>
            </div>
          </div>
        )}

      </div>

      {/* Bottom Nav for navlinks */}
      <BottomNav categories={categories} menuRef={menuRef} />
    </>
  );
};

export default Navbar;
